/* eslint-disable complexity */
import {data} from './interface';
import {Loading, Loaded, NoResult, LoadError, CloseTips} from './status';
import {useEffect, useRef, useState} from 'react';
import styles from './index.module.scss';
import {dateFormatBrowseRecords} from '@/utils/dateUtils';
import {useIntl} from 'react-intl';
import ExternalLabel from '@/components/ExternalLabel';

interface IProps {
    list: data[];
    error: boolean;
    loading: boolean;
    pageView: number | undefined;
    closeRecentBrowseRecords: boolean;
    reload: () => void;
}

/*
  参考恒恒写的滚动加载写的；可能写的不优雅，后续优化。
*/
export function SidebarSearchList(props: IProps) {
    const {
        list,
        error = false,
        loading,
        pageView,
        closeRecentBrowseRecords,
        reload,
    } = props;
    const isLoadData = useRef(false);
    const page = useRef(1);
    const intl = useIntl();
    const [dataTimeGroup, setDataTimeGroup] = useState<any[]>([]);

    function timeGroup() {
        const newLest = list.map((item: any) => {
            item.recent = dateFormatBrowseRecords(Number(item.recent), intl);
            return item;
        });
        const timeGroup: string | any[] = [];
        let lastTime = '';
        for (const iterator of newLest) {
            if (iterator.recent === lastTime) {
                // console.log(Object.keys(timeGroup[timeGroup.length - 1])[0]);
                // eslint-disable-next-line max-len
                timeGroup[timeGroup.length - 1][Object.keys(timeGroup[timeGroup.length - 1])[0]].push(iterator);
            } else {
                timeGroup.push({[iterator.recent]: [iterator]});
            }
            lastTime = iterator.recent;
        }
        setDataTimeGroup(timeGroup);
    }

    useEffect(() => {
        isLoadData.current = false;
        timeGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [list]);

    return (
        <div className={styles.root}>
            <div
                className="browse-box"
            >
                <div className={styles.confirmNumber}>
                    {loading && list.length === 0
                        ? <div className={styles.framework}></div>
                        : <div>总浏览数：{pageView}</div>
                    }
                </div>
                {
                    dataTimeGroup.map((item: any) => {
                        return (
                            <>
                                <div className={styles.timeGroup}>{Object.keys(item)[0]}</div>
                                {item[Object.keys(item)[0]].map((item: any) => {
                                    return (
                                        <>
                                            <div
                                                className={styles.item}
                                                // eslint-disable-next-line react/no-array-index-key
                                                key={`${item.recent}`}
                                            >
                                                <div className={styles.line}></div>
                                                <div className={styles.imgBox}>
                                                    <img src={item.avatarUrl} className={styles.imgStyles} />
                                                </div>
                                                <div className={styles.context}>
                                                    <div className={styles.nameAndDepartment}>
                                                        <span className={styles.name}>
                                                            {item.nickname}
                                                        </span>
                                                        {
                                                            item.external ? <ExternalLabel labelName={'外部'} /> : null
                                                        }
                                                        <span className={styles.department}>
                                                            {item.department}
                                                        </span>
                                                    </div>
                                                    <div className={styles.email}>
                                                        {
                                                            item.external ? item.passportDisplayName : item.email
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    );
                                })
                                }
                            </>
                        );
                    })
                }
                {
                    loading && !list?.length
                        // 不用fill填充的话map不会遍历
                        ? [...Array(6).fill(0)].map((item: number, index: number) => {
                        // [...Array(6).fill(1)].map((index: number) => { // 验证骨架图
                            return (
                                <div
                                    className={styles.item}
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={`${index}`}
                                >
                                    <div className={styles.imgBox}>
                                        <div className={styles.imgFramework}></div>
                                    </div>
                                    <div className={styles.context}>
                                        <div className={styles.nameAndDepartmentFramework}></div>
                                        <div className={styles.emailFramework}></div>
                                    </div>
                                    <div className={styles.timeFramework}> </div>
                                </div>
                            );
                        })
                        : null
                }
                {
                    loading && list.length !== 0
                        ? <Loading />
                        : null
                }
                {
                    closeRecentBrowseRecords
                        ? <CloseTips />
                        : null
                }
                {
                    loading && list.length !== 0
                        ? <Loading />
                        : null
                }
                {
                    list.length === 0 && !error && !loading
                        ? <NoResult />
                        : null
                }
                {
                    list.length > 0 && !error && !loading
                        ? <Loaded />
                        : null
                }
                {
                    error && !loading
                        ? <LoadError
                            onReload={
                                () => {
                                    reload();
                                }
                            }
                        />
                        : null
                }
            </div>
        </div>

    );
}
